import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";

import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Tooltip,
} from "@mui/material";
import {
  Cancel as NoImageIcon,
  Pin as PinnedIcon,
  EyeOff as UnpublishedIcon,
} from "mdi-material-ui";

import { Menu as MenuIcon } from "mdi-material-ui";
import { gql } from "@apollo/client";

export default function ArticlesListItem({ article, index }) {
  const title = article.artistName ?? article.title?.fr;

  return (
    <Draggable draggableId={article.id} index={index}>
      {(provided, snapshot) => (
        <ListItem
          component={Link}
          to={`/articles/${article.id}`}
          button
          ref={provided.innerRef}
          {...provided.draggableProps}
          dense
          divider
        >
          <ListItemIcon {...provided.dragHandleProps}>
            <MenuIcon />
          </ListItemIcon>

          <ListItemAvatar>
            <Avatar src={article.teaserImage?.url}>
              {!article.teaserImage?.url && <NoImageIcon />}
            </Avatar>
          </ListItemAvatar>

          <ListItemText primary={title} secondary={article.section?.label.fr} />

          <ListItemSecondaryAction>
            {article.pinned && (
              <Tooltip placement="top" title="Épinglé">
                <PinnedIcon color="disabled" />
              </Tooltip>
            )}

            {!article.published && (
              <Tooltip placement="top" title="Non publié">
                <UnpublishedIcon color="disabled" />
              </Tooltip>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      )}
    </Draggable>
  );
}

ArticlesListItem.fragments = {
  article: gql`
    fragment ArticlesListItem_Article on Article {
      id
      published

      title {
        fr
      }

      teaserImage {
        id
        url
      }

      ... on Article_Artist {
        artistName
      }

      ... on Article_BlogPost {
        pinned

        section {
          id
          label {
            fr
          }
        }
      }
    }
  `,
};
